import React, { useState, useRef } from "react";
import { connect } from "react-redux";
import { Alert } from "react-bootstrap";
import KpiSummaryChevron from "./KpiSummaryChevron";
import PropTypes from "prop-types";

function KpiSummaryScenarioAdvanceSearchModal(props) {
    const [setActive, setActiveState] = useState("");
    const [setHeight, setHeightState] = useState("0px");
    const [setRotate, setRotateState] = useState("chevron_icon");

    const content = useRef(null);

    function toggleButton() {
        setActiveState(setActive === "" ? "activeFilterModal" : "");
        setHeightState(
            setActive === "activeFilterModal" ? "0px" : `${content.current.scrollHeight}px`
        );
        setRotateState(setActive === "activeFilterModal" ? "chevron_icon" : "chevron_icon rotate");
    }

    console.log("meta deta results ->", props.metaData);
    return (
        <div style={{ display: "flex", flexDirection: "column", backgroundColor: "#C7C9FF" }}>
            <button
                className={`kpisummaryadvancefilter ${setActive}`}
                style={{ color: "white", backgroundColor: "#757AF7" }}
                onClick={toggleButton}
            >
                Execution Summary Meta Information
                <KpiSummaryChevron className={`${setRotate}`} />
            </button>

            <div
                ref={content}
                style={{
                    maxHeight: `${setHeight}`,
                    overflow: "hidden",
                    transition: "max-height 0.3s ease",
                }}
            >
                <div className="col-md-12">
                    {props.metaDataError ? (
                        <Alert key="danger" variant="danger">
                            {props.metaDataError}
                        </Alert>
                    ) : (
                        <div className="row" style={{ paddingBottom: "0.5rem" }}>
                            <div className="col-md-12">
                                <div
                                    className="row mytab"
                                    id="hover"
                                    style={{
                                        backgroundColor: "#E2E3FF",
                                        fontSize: "1rem",
                                        color: "#464646",
                                        margin: "2% 0%",
                                        padding: "1%",
                                    }}
                                >
                                    <div
                                        className="col-md-5 text-left"
                                        style={{ color: "#464646" }}
                                    >
                                        Topology Name
                                    </div>
                                    <div
                                        className="col-md-7 text-right"
                                        style={{ color: "#464646" }}
                                    >
                                        {props.metaData.cad_topology_name}
                                    </div>
                                </div>
                                {/* <div
                                    className="row mytab"
                                    id="hover"
                                    style={{
                                        backgroundColor: "#E2E3FF",
                                        fontSize: "1rem",
                                        color: "#464646",
                                        margin: "2% 0%",
                                        padding: "1%",
                                    }}
                                >
                                    <div
                                        className="col-md-6 text-left"
                                        style={{
                                            color: "#464646",
                                            display: "inline-block",
                                        }}
                                    >
                                        Carla Version
                                    </div>
                                    <div
                                        className="col-md-6 text-right"
                                        style={{
                                            color: "#464646",
                                            display: "inline-block",
                                        }}
                                    >
                                        {props.metaData.carla_version}
                                    </div>
                                </div> */}
                                <div
                                    className="row mytab"
                                    id="hover"
                                    style={{
                                        backgroundColor: "#E2E3FF",
                                        fontSize: "1rem",
                                        color: "#464646",
                                        margin: "2% 0%",
                                        padding: "1%",
                                    }}
                                >
                                    <div
                                        className="col-md-6 text-left"
                                        style={{
                                            color: "#464646",
                                            display: "inline-block",
                                        }}
                                    >
                                        Modal
                                    </div>
                                    <div
                                        className="col-md-6 text-right"
                                        style={{
                                            color: "#464646",
                                            display: "inline-block",
                                        }}
                                    >
                                        {props.metaData.modal}
                                    </div>
                                </div>
                                <div
                                    className="row mytab"
                                    id="hover"
                                    style={{
                                        backgroundColor: "#E2E3FF",
                                        fontSize: "1rem",
                                        color: "#464646",
                                        margin: "2% 0%",
                                        padding: "1%",
                                    }}
                                >
                                    <div
                                        className="col-md-6 text-left"
                                        style={{
                                            color: "#464646",
                                            display: "inline-block",
                                        }}
                                    >
                                        Frequency
                                    </div>
                                    <div
                                        className="col-md-6 text-right"
                                        style={{
                                            color: "#464646",
                                            display: "inline-block",
                                        }}
                                    >
                                        {props.metaData.frequency}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    metaData: state.executionMetaData.executionMetaData,
    metaDataError: state.executionMetaData.error,
});

KpiSummaryScenarioAdvanceSearchModal.propTypes = {
    metaData: PropTypes.object,
    metaDataError: PropTypes.string,
};
KpiSummaryScenarioAdvanceSearchModal.defaultProps = {
    metaData: {},
    metaDataError: "",
};

export default connect(mapStateToProps, undefined)(KpiSummaryScenarioAdvanceSearchModal);
